var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navigation-section button",on:{"click":_vm.click}},[_c('div',{staticClass:"icon-container"},[_vm._t("icon")],2),_c('div',[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('h6',[_vm._v(_vm._s(_vm.subtitle))])])])}
var staticRenderFns = []

export { render, staticRenderFns }